































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'MyAccount',
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            error: '',
            disableButton: false
        }
    },
    created() {
        this.$store.state.routeLoaded = true;
    },
    methods: {
        accountLabel(acc: any): string {
            return acc.AccountName || `Account ${acc.HSPortalId}`;
        },
        submit() {
            if(this.disableButton) return;
            this.disableButton = true;
            this.error = '';
            axios.post(this.$store.state.apiUrl + '/auth/change-password', {
                currentPassword: this.currentPassword,
                newPassword: this.newPassword
            })
                .then(() => {
                    this.disableButton = false;
                    this.currentPassword = '';
                    this.newPassword = '';
                    alert('Your password has been updated.');
                })
                .catch(e => {
                    this.disableButton = false;
                    this.error = e.response ? e.response.data : 'There was an error updating your password.';
                });
        }
    }
})
